import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { ActionType, CouponInfoBaseForm, Campaign3DuplicateAction, MessageType } from 'app/views/campaign-3/models/campaign-3-info-base.model';
import { GenerazioneDropdown, FruizioneDropdown } from 'app/views/campaign-3/models/campaign-3-planning.model';
import { MessageInstanceObject, Campaign3Info, Campaign3StatusMapping, JsonSchema, CalculateFruitionDateRequest } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { Campaign3CreateExistingMessage } from './create-message-from-existing/create-message-from-existing.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-message-3-info-base',
  templateUrl: './message-3-info-base.component.html',
  styleUrls: ['./message-3-info-base.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3InfoBaseComponent implements OnInit {


  errors: boolean = false;

  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;

  @Input() comboGiornoSettimanaFineFruizione: Array<{ day: number, name: string }>
  @Input() campaignInfo: Campaign3Info = null;
  @Input() readOnly: boolean = false;
  @Input() statusMapping: Campaign3StatusMapping;

  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";


  @Input() comboInizioFruizione: Array<GenerazioneDropdown>;
  @Input() comboFineFruizione: Array<FruizioneDropdown>;

  @Input() schemaMode: string = this.srvCampaign3.schema_modes.CREATE;

  @Input() actionTypesList: Array<ActionType> = [];

  //da sostituire nuovo CouponType
  /*  @Input() comboCouponType: Array<CouponType> = []; */
  @Input() comboMessageType: Array<MessageType> = [];





  @Output() enableConfirmButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();
  @Output() actionTypeChanged: EventEmitter<string> = new EventEmitter<string>();


  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();

  @ViewChild('message_type') message_type: FormFields;

  @ViewChild('name') name: FormFields;
  @ViewChild('int_code') int_code: FormFields;
  @ViewChild('public_description') public_description: FormFields;
  @ViewChild('int_note') int_note: FormFields;

  @ViewChild('fromExisting') fromExistingComponent: Campaign3CreateExistingMessage;


  infoBaseCouponForm: CouponInfoBaseForm = new CouponInfoBaseForm();


  fieldNames = {
    message_type: "tipo_messaggio",
    name: "name",
    public_description: "description",
    int_code: "code",
    int_note: "note"
  }

  fieldModel = {
    message_type: null,
    name: null,
    public_description: null,
    int_code: null,
    int_note: null
  }

  actionType = {
    currentCode: "",
    width: 100
  }

  ready = {
    form: false
  }

  show = {
    //   actionType: false,
    formCoupon: false,
    new_or_exists: false,
    popup_fromCoupon: false,
    popup_fromAction: false,
    fromExistingButtons: false,
    tipoMessage: false
  }


  private dateErrors: {
    emission: string;
  
  } = {
      emission: '',
  
    };


  payloadForFruitionDate: CalculateFruitionDateRequest = null;

  existingModalTitle = "";

  constructor(public srvCampaign3: Campaign3Service,
    private msgService: MessageService,
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    private confirmationService: ConfirmationService,

    private router: Router) {
  }

  ngOnInit() {


    console.log(this.actionTypesList);


    this.existingModalTitle = this.campaignInfo.name + " - Crea coupon da esistente";
    this.actionType.width = (100 / this.actionTypesList.length);
    //this.show.actionType = true;


  // fallback SINCRONO
this.dateErrors = {
  emission: this.srvTranslate.instant('campaign.emission_end_before_start'),
};

// override async (quando arrivano le traduzioni vere)
Observable.zip(
  this.srvTranslate.get('campaign.emission_end_before_start'),
).subscribe(([emission]) => {
  this.dateErrors.emission = emission;

});



    //Modificato perchè siamo nel caso messaggio
    this.onClickActionType(this.srvCampaign3.actionTypes.MESSAGE.code, true);
    if (this.messageInstanceObject && this.ui_mode == this.srvCampaign3.ui_modes.EDIT) {
      this.onClickNew();
      this.onChangeMessageType(this.comboMessageType.find(x => x.id == this.messageInstanceObject.messageId));
    }
  }
  onClickNew() {

    this.show.tipoMessage = true;
    this.fieldModel.message_type = null;
    //this.show.formCoupon = true;

    if (this.ui_mode == this.srvCampaign3.ui_modes.EDIT) {
      var self = this;
      setTimeout(function () {
        let messageType = self.comboMessageType.find(x => x.id == self.messageInstanceObject.messageId);
        self.fieldModel.message_type = messageType;
        //self.coupon_type.disabled = true;
      }, 100);
    }
    //  spostato dopo la selezione del messageType
    //  this.enableConfirmButton.emit(true);
  }

  onChangeMessageType(messageType: MessageType) {
    //carica il form schema a seconda della scelta della combo tipo coupon
    if (messageType) {
      this.ready.form = false;
      var self = this;

      this.srvCampaign3.getJsonFormSchemaMessage(this.actionType.currentCode, this.schemaMode, messageType.id.toString()).subscribe(resSchema => {
        if (resSchema && resSchema.length == 1) {
          let newSchema = self.srvCampaign3.getPreparedFormSchemas(resSchema[0]);
          self.formSchema = null;
          setTimeout(function () {
            self.formSchema = newSchema.properties.infoBase;
            newSchema.mode = self.schemaMode;
            self.formSchemaChanged.emit(newSchema);

            var self2 = self;

            setTimeout(function () {
              self2.loadInfoBaseModelAfterCouponType(messageType);
              self2.ready.form = true;
              self2.enableConfirmButton.emit(true);
            })

          }, 100);

        }
        else {
          //caso non viene restituito schema, devi fermarti (da gestire)!
          self.formSchemaChanged.emit(null);
          self.srvMessage.add({
            severity: 'error',
            summary: this.srvTranslate.instant('common.error'),
            detail: this.srvTranslate.instant('common.no_template_schema')  
          });
        }

      });
    }
  }
  onMessageInstanceSelected(isSelected: boolean) {
    this.show.fromExistingButtons = isSelected == true ? true : false;
  }
  loadInfoBaseModelAfterCouponType(messageType: MessageType) {
    this.fieldModel.message_type = messageType;


    this.fieldModel.int_code = this.messageInstanceObject.code ? this.messageInstanceObject.code : null;
    this.fieldModel.public_description = this.messageInstanceObject.description;
    this.fieldModel.name = this.messageInstanceObject.name ? this.messageInstanceObject.name : null;
    this.fieldModel.int_note = this.messageInstanceObject.notes ? this.messageInstanceObject.notes : null;

  }
  onClickExists() {
    if (this.actionType.currentCode == this.srvCampaign3.actionTypes.COUPON.code) {
      this.show.popup_fromCoupon = true;
    }
    else if (this.actionType.currentCode == this.srvCampaign3.actionTypes.MESSAGE.code) {
      this.show.popup_fromAction = true;
    }
    else {

    }
    this.show.formCoupon = false;
    this.enableConfirmButton.emit(false);

  }

  onDialogHide() {
    if (this.fieldModel.message_type) {
      this.enableConfirmButton.emit(true);
    }

  }
  onClickActionType(codeActionType: string, isFromInit: boolean = false) {
    if (this.ui_mode == this.srvCampaign3.ui_modes.CREATE || isFromInit) {
      this.ready.form = false;
      this.show.tipoMessage = false;
      this.enableConfirmButton.emit(false);
      this.actionType.currentCode = codeActionType;

      if (this.actionType.currentCode == this.srvCampaign3.actionTypes.COUPON.code) {
        this.show.new_or_exists = true;
        this.show.formCoupon = false;
      }
      else if (this.actionType.currentCode == this.srvCampaign3.actionTypes.MESSAGE.code) {
        this.show.formCoupon = false;
        this.show.new_or_exists = true;
      }
      else {
        this.show.formCoupon = false;
        this.show.new_or_exists = false;
      }
      //this.messageInstanceObjectChange.emit(this.messageInstanceObject);
      this.actionTypeChanged.emit(this.actionType.currentCode);
    }
  }
  performValidationInfoBase(): boolean {

    this.infoBaseCouponForm.valid = true;
    this.int_code.performValidation();
    this.int_note.performValidation();
    this.name.performValidation();
    this.public_description.performValidation();
    this.message_type.performValidation();

    if (
      !this.int_code.valid ||
      !this.int_note.valid ||
      !this.public_description.valid ||
      !this.name.valid ||
      !this.message_type.valid) {
      this.infoBaseCouponForm.valid = false;
    }
    return this.infoBaseCouponForm.valid;
  }
  onClickCancelFromExisting() {
    this.show.popup_fromCoupon = false;
  }
  calculatePayloadForFruitionDate() {

    /*   let payload = new CalculateFruitionDateRequest();
      payload.flg_rolling = this.fromExistingComponent.switch.variable == true ? "1" : "0";
      payload.start_fruition_date = this.fromExistingComponent.fieldModel.data_inizio_fruizione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_fruizione) : this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.campaignInfoFrom.dateStart);
      payload.end_fruition_date = this.fromExistingComponent.fieldModel.data_fine_fruizione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_fruizione) : this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.campaignInfoFrom.dateEnd);
      payload.coupon_validity_date_start_mode = this.fromExistingComponent.fieldModel.modalita_inizio_fruizione ? this.fromExistingComponent.fieldModel.modalita_inizio_fruizione.code : null;
      payload.coupon_validity_date_start = this.fromExistingComponent.fieldModel.data_inizio_fruizione_fissa ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_fruizione_fissa) : null;
      payload.coupon_validity_start_offset_day = this.fromExistingComponent.fieldModel.offset_inizio_fruizione;
      payload.coupon_validity_start_week_day = this.fromExistingComponent.fieldModel.giorno_settimana_inizio ? this.fromExistingComponent.fieldModel.giorno_settimana_inizio.day : null;
      payload.coupon_validity_date_end_mode = this.fromExistingComponent.fieldModel.modalita_fine_fruizione ? this.fromExistingComponent.fieldModel.modalita_fine_fruizione.code : null;
      payload.coupon_validity_date_end = this.fromExistingComponent.fieldModel.data_fine_fruizione_fissa ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_fruizione_fissa) : null;
      payload.coupon_validity_end_offset_day = this.fromExistingComponent.fieldModel.offset_fine_fruizione;
      payload.coupon_validity_end_week_day = this.fromExistingComponent.fieldModel.giorno_settimana_fine ? this.fromExistingComponent.fieldModel.giorno_settimana_fine.day : null;
      this.payloadForFruitionDate = Object.assign({}, payload); */
  }

  calculatePayloadForFruitionDateFromMessageInstance() {
    let payload = new CalculateFruitionDateRequest();
    payload.flg_rolling = this.fromExistingComponent.messageInstanceComplete.flgRolling;
    payload.start_fruition_date = this.fromExistingComponent.messageInstanceComplete.startFruitionDate ? this.fromExistingComponent.messageInstanceComplete.startFruitionDate : this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.campaignInfoFrom.dateStart);
    payload.end_fruition_date = this.fromExistingComponent.messageInstanceComplete.endFruitionDate ? this.fromExistingComponent.messageInstanceComplete.endFruitionDate : this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.campaignInfoFrom.dateEnd);
    payload.coupon_validity_date_start_mode = this.fromExistingComponent.messageInstanceComplete.couponValidityDateStartMode;
    payload.coupon_validity_date_start = this.fromExistingComponent.messageInstanceComplete.couponValidityDateStart;
    payload.coupon_validity_start_offset_day = this.fromExistingComponent.messageInstanceComplete.couponValidityStartOffsetDay;
    payload.coupon_validity_start_week_day = this.fromExistingComponent.messageInstanceComplete.couponValidityStartWeekDay;
    payload.coupon_validity_date_end_mode = this.fromExistingComponent.messageInstanceComplete.couponValidityDateEndMode;
    payload.coupon_validity_date_end = this.fromExistingComponent.messageInstanceComplete.couponValidityDateEnd;
    payload.coupon_validity_end_offset_day = this.fromExistingComponent.messageInstanceComplete.couponValidityEndOffsetDay;
    payload.coupon_validity_end_week_day = this.fromExistingComponent.messageInstanceComplete.couponValidityEndWeekDay;
    this.payloadForFruitionDate = Object.assign({}, payload);
  }

    private showDateError(message: string): void {
    this.msgService.add({
      severity: 'error',
      summary: this.srvTranslate.instant('common.error'),
      detail: message
    });
  }


   private validateDates(model: any): boolean {
    var startEmission = model.data_inizio_emissione;
    var endEmission = model.data_fine_emissione;
 
    // emissione
    if (startEmission && endEmission && endEmission < startEmission) {
      this.showDateError(this.dateErrors.emission);
      return false;
    }


    return true;
  }
  onClickCreateFromExisting() {
    let valid = true;

    if (this.fromExistingComponent) {

      if (this.fromExistingComponent.new_name) this.fromExistingComponent.new_name.performValidation();
      if (this.fromExistingComponent.existingArticoloCoupon) this.fromExistingComponent.existingArticoloCoupon.performValidation();
      if (this.fromExistingComponent.existingSoloBarcodeText) this.fromExistingComponent.existingSoloBarcodeText.performValidation();
      if (this.fromExistingComponent.existingSoloBarcode) this.fromExistingComponent.existingSoloBarcode.performValidation();
      if (this.fromExistingComponent.existingComboBarcodesComponent) this.fromExistingComponent.existingComboBarcodesComponent.performValidation();
      if (this.fromExistingComponent.existing_data_inizio_emissione) this.fromExistingComponent.existing_data_inizio_emissione.performValidation();
      if (this.fromExistingComponent.existing_data_fine_emissione) this.fromExistingComponent.existing_data_fine_emissione.performValidation();
      /*   if (this.fromExistingComponent.existing_data_inizio_fruizione) this.fromExistingComponent.existing_data_inizio_fruizione.performValidation();
        if (this.fromExistingComponent.existing_data_inizio_fruizione) this.fromExistingComponent.existing_data_inizio_fruizione.performValidation(); */


      let validations = {
        new_name: this.fromExistingComponent.new_name ? this.fromExistingComponent.new_name.valid : true,
        existingArticoloCoupon: this.fromExistingComponent.existingArticoloCoupon ? this.fromExistingComponent.existingArticoloCoupon.valid : true,
        existingSoloBarcodeText: this.fromExistingComponent.existingSoloBarcodeText ? this.fromExistingComponent.existingSoloBarcodeText.valid : true,
        existingSoloBarcode: this.fromExistingComponent.existingSoloBarcode ? this.fromExistingComponent.existingSoloBarcode.valid : true,
        existingComboBarcodesComponent: this.fromExistingComponent.existingComboBarcodesComponent ? this.fromExistingComponent.existingComboBarcodesComponent.valid : true,
        existing_data_inizio_emissione: this.fromExistingComponent.existing_data_inizio_emissione ? this.fromExistingComponent.existing_data_inizio_emissione.valid : true,
        existing_data_fine_emissione: this.fromExistingComponent.existing_data_fine_emissione ? this.fromExistingComponent.existing_data_fine_emissione.valid : true,
        /*   existing_data_inizio_fruizione: this.fromExistingComponent.existing_data_inizio_fruizione ? this.fromExistingComponent.existing_data_inizio_fruizione.valid : true,
          existing_data_fine_fruizione: this.fromExistingComponent.existing_data_fine_fruizione ? this.fromExistingComponent.existing_data_fine_fruizione.valid : true */
      }

      for (let key in validations) {
        if (validations[key] == false) {
          valid = false;
          return;
        }
      }

      if (valid) {


        if (!this.validateDates(this.fromExistingComponent.fieldModel)) {
          return;
        }

        let checkBarcode = {
          start_emission_date: this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_emissione),
          end_emission_date: this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_emissione),
          start_fruition_date: null,
          end_fruition_date: null
        };
        //in questo caso sono definite dall'utente le date di inizio e fine fruizione
        //TODO
        /*          if (this.fromExistingComponent.fieldModel.data_inizio_emissione && this.fromExistingComponent.fieldModel.data_fine_emissione && this.fromExistingComponent.fieldModel.data_inizio_fruizione && this.fromExistingComponent.fieldModel.data_fine_fruizione) {
        
                 
                  checkBarcode.start_fruition_date = this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_fruizione);
                  checkBarcode.end_fruition_date = this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_fruizione);
        
                  this.checkBarcode(checkBarcode);
        
                }
                else if (this.fromExistingComponent.fieldModel.modalita_inizio_fruizione && this.fromExistingComponent.fieldModel.modalita_inizio_fruizione) {
        
                  this.calculatePayloadForFruitionDate();
        
                  var self = this;
                  this.srvCampaign3.calculateFruitionDate(this.payloadForFruitionDate).subscribe(res => {
        
                    if (res) {
                      checkBarcode.start_fruition_date = res.fruition_date_start;
                      checkBarcode.end_fruition_date = res.fruition_date_end;
                      self.checkBarcode(checkBarcode);
                    }
                    else {
                      self.msgService.add({ severity: 'error',  summary: this.srvTranslate.instant('common.error'), detail: 'Errore nel calcolo delle data di fruizione!' });
                    }
        
        
                  });
                } 
                 if (this.fromExistingComponent.messageInstanceComplete.startFruitionDate && this.fromExistingComponent.messageInstanceComplete.endFruitionDate) {
                  checkBarcode.start_fruition_date = this.fromExistingComponent.messageInstanceComplete.startFruitionDate;
                  checkBarcode.end_fruition_date = this.fromExistingComponent.messageInstanceComplete.endFruitionDate;
                  this.checkBarcode(checkBarcode);
                } */

        //sistemo il payload
        this.calculatePayloadForFruitionDateFromMessageInstance();

        var self = this;
        this.srvCampaign3.calculateFruitionDate(this.payloadForFruitionDate).subscribe(res => {

          if (res) {
            checkBarcode.start_fruition_date = res.fruition_date_start;
            checkBarcode.end_fruition_date = res.fruition_date_end;
            self.checkBarcode(checkBarcode);
          }
          else {
            self.msgService.add({
              severity: 'error',
              summary: this.srvTranslate.instant('common.error'), // Mantieni in inglese
              detail: this.srvTranslate.instant('campaign.error_calculating_fruition_dates')
            });
          }

        });

      }
    }
  }
  checkBarcode(checkBarcodePayload: any) {

    //let barcodeString = (this.fromExistingComponent.fieldModel.articoloCoupon && this.fromExistingComponent.fieldModel.barcodeCoupon) ? this.fromExistingComponent.fieldModel.barcodeCoupon.barcode : this.fromExistingComponent.existingSoloBarcode.fieldModel;

    let barcodeString = "";

    if (this.fromExistingComponent.fieldModel.articoloCoupon.articolo && this.fromExistingComponent.fieldModel.articoloCoupon.barcode) {
      barcodeString = this.fromExistingComponent.fieldModel.articoloCoupon.barcode.barcode;
    }
    else if (this.fromExistingComponent.fieldModel.barcodeManualCoupon) {
      barcodeString = this.fromExistingComponent.fieldModel.barcodeManualCoupon;
    }
    if (barcodeString) {
      var self = this;
      checkBarcodePayload.message_instance_id = this.messageInstanceObject.id;
      //checkBarcodePayload.campaign_id = this.campaignInfo.id //opzionale
      checkBarcodePayload.barcode = barcodeString;
      this.srvCampaign3.checkBarcodeAvailability(checkBarcodePayload).subscribe(res => {
        if (res == true) {
          self.performDuplicateAction(checkBarcodePayload, barcodeString);
        }
        else {
          this.confirmationService.confirm({
            header: this.srvTranslate.instant('common.warning'),
            message: this.srvTranslate.instant('campaign.checkBarcodeStop'),
            acceptLabel: 'Ok',
            rejectVisible: false
          });
        }
      });
    }
  }
  performDuplicateAction(checkBarcode: any, barcodeString: string) {

    //duplicazione azione
    let duplicateObj = new Campaign3DuplicateAction();
    duplicateObj.idCampaignFrom = this.fromExistingComponent.campaignInfoFrom.id;
    duplicateObj.idCampaignTo = this.fromExistingComponent.campaignInfoTo.id;

    duplicateObj.start_date_emission = checkBarcode.start_emission_date;
    duplicateObj.end_date_emission = checkBarcode.end_emission_date;
    /*
    duplicateObj.start_date_emission = this.fromExistingComponent.fieldModel.data_inizio_emissione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_emissione) : null;
    duplicateObj.end_date_emission = this.fromExistingComponent.fieldModel.data_fine_emissione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_emissione) : null;
    */



    duplicateObj.barcode = barcodeString;
    //duplicateObj.codice_articolo = this.fromExistingComponent.fieldModel.articoloCoupon ? this.fromExistingComponent.fieldModel.articoloCoupon.product_code : null
    duplicateObj.codice_articolo = this.fromExistingComponent.fieldModel.articoloCoupon.articolo ? this.fromExistingComponent.fieldModel.articoloCoupon.articolo.id : null
    /*  duplicateObj.start_date_fruition = checkBarcode.start_fruition_date;
     duplicateObj.end_date_fruition = checkBarcode.end_fruition_date; */
    /*
    duplicateObj.start_date_fruition = this.fromExistingComponent.fieldModel.data_inizio_fruizione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_inizio_fruizione) : null;
    duplicateObj.end_date_fruition = this.fromExistingComponent.fieldModel.data_fine_fruizione ? this.srvCampaign3.getDateStringDBFromDate(this.fromExistingComponent.fieldModel.data_fine_fruizione) : null;
    */
    duplicateObj.messageInstanceId = this.fromExistingComponent.messageInstanceComplete.id;
    duplicateObj.newActionname = this.fromExistingComponent.fieldModel.new_name;
    duplicateObj.barcode_type_pid = this.fromExistingComponent.switch.soloBarcode ? 1 : 0;
    var self = this;

    //TODO devo aspettare che antonio mi tiri fuori l'id dell'oggetto duplicato
    var self = this;
    let newIndex;
    let newIdCampaign;
    this.srvCampaign3.duplicateCampaignAction(duplicateObj).subscribe(res => {
      if (res) {
        newIndex = res.id;
        newIdCampaign = res.campaign_id;
        self.msgService.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'),
          detail: this.srvTranslate.instant('common.operation_success')
        });
      }
      else {
        self.msgService.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('common.error')
        });
      }
      self.show.popup_fromCoupon = false;
      let routerUrl = ["campaign-3", newIdCampaign, newIndex, "MSG"];
      self.router.navigate(routerUrl);


    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-info-base/message-3-info-base.component.ts